// @ts-nocheck
export const localeCodes =  [
  "en",
  "es"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_661b6c44",
      load: () => import("#nuxt-i18n/661b6c44" /* webpackChunkName: "locale_en_46json_661b6c44" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_68355a63",
      load: () => import("#nuxt-i18n/68355a63" /* webpackChunkName: "locale_es_46json_68355a63" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/949ed66c" /* webpackChunkName: "config_i18n_46config_46ts_949ed66c" */)
]
export const normalizedLocales = [
  {
    code: "en",
    dir: "ltr",
    language: undefined
  },
  {
    code: "es",
    dir: "ltr",
    language: undefined
  }
]
/** client **/

/** client-end **/